let notificationPanel = null;

// Options param is optional.
// Options param can have properties.
// - sender
// - route
//
// Sender property is optional.
// Specify sender property, if you want to delete all notifications (the sender sent) later.
//
// Route property is optional.
// There is automatic notification deletion.
// By default notification corresponds current route.
// When user navigates to next route, all notifications for previous route will be automatically deleted.
// If new notification must be visible at next route, specify route property. Use value 'next'.
// It is used to show success notification and navigate to next route.

export default {
  setNotificationPanel(panel) {
    notificationPanel = panel;
  },

  showSuccess(message, options) {
    if(notificationPanel === null) {
      console.log(message);
      return;
    }
    notificationPanel.showSuccess(message, options);
  },

  showSuccessAfterTransition(message) {
    if(notificationPanel === null) {
      console.log(message);
      return;
    }
    notificationPanel.showSuccessAfterTransition(message);
  },

  showWarning(message) {
    if(notificationPanel === null) {
      console.log(message);
      return;
    }
    notificationPanel.showWarning(message);
  },

  showError(err, options) {
    if(notificationPanel === null) {
      console.error(err);
      return;
    }

    const message = getErrorMessage(err);
    notificationPanel.showError(message, options);
  },

  deleteSenderNotifications(sender) {
    if(notificationPanel === null) {
      return;
    }
    notificationPanel.deleteSenderNotifications(sender);
  }
};


function getErrorMessage(err) {
  if(err === undefined) {
    return 'Error. err === undefined';
  }

  if(err === null) {
    return 'Error. err === null';
  }

  const isErrString = (typeof err === 'string');
  if(isErrString) {
    if(err.length === 0) {
      return 'Error. No error message. Error message length === 0.';
    }
  }

  const isErrObject = (typeof err === 'object');
  if(isErrObject) {
    if(('response' in err) && ('data' in err.response)) {
      const data = err.response.data;
      if(data !== undefined) {
        return data;
      }
    }
  }

  return err.toString();
}
